<template>
  <div
    class="podcast-episodes"
    data-test="podcast-episodes">
    <div
      v-if="isLoggedIn"
      class="container">
      <loader
        v-show="!episodes_loaded"
        center
        label="Fetching Podcasts Episodes ..."/>
      <library-menu
        :display-list="true"
        text="Latest Episodes"/>
      <!-- Empty Shows Box -->
      <empty-shows
        v-show="!podcasts_episodes.length && episodes_loaded"
        option="podcast-episodes"/>

      <!-- Display Podcasts Episodes-->
      <div
        v-if="podcasts_episodes.length && episodes_loaded">
        <card-list-wrapper
          :episodes="podcasts_episodes"
          :bucket="{
            bucket_uuid: null,
            name: 'Latest Episodes',
            bucket_type:'episodes',
            position: 0,
            items_count: podcasts_episodes.length,
            media_size: 'episode_details'
          }"
          playlist-type="my-shows"
          data-test="latest-episodes"
        />
      </div>
      <loader
        v-show="podcasts_episodes.length && loading_more_episodes && !no_more_episodes"
        :with-margin="true" />
    </div>
  </div>
</template>
<script>
import Episode from '../../services/Episode';
import User from '../../services/User';
import CardListWrapper from '../../components/CardListWrapper';
import loader from '../../components/Loader';
import EmptyShows from '../../components/EmptyShows';
import LibraryMenu from '../../components/LibraryMenu';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'Shows',
  components: {
    loader,
    'card-list-wrapper': CardListWrapper,
    'empty-shows': EmptyShows,
    'library-menu': LibraryMenu,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'My Shows',
      episode_service: new Episode(),
      user_service: new User(),
      podcasts_episodes: [],
      podcasts_episodes_response: [],
      episode_key_map: {},
      episodes_loaded: false,
      no_more_episodes: false,
      loading_more_episodes: false,
      page: 0,
      limit: 25,
      scroll_threshold: 200,
      isLoggedIn: this.$store.getters.loggedIn,
    };
  },
  beforeMount() {
    if (this.isLoggedIn) {
      this.loadPodcastEpisodeData();
    }
  },
  mounted() {
    this.ifiniteScrollPodcastEpisodes();
  },
  beforeDestroy() {
    this.removeScrollEvent();
  },
  methods: {
    isExclusive(item) {
      return (item.season && item.season.podcast && item.season.podcast.is_exclusive) || false;
    },
    isFreeEpisode(item) {
      return (item.season && item.season.podcast && item.season.podcast.is_exclusive) && !item.is_exclusive;
    },
    loadPodcastEpisodeData() {
      this.loading_more_episodes = true;
      if (this.no_more_episodes) {
        this.episodes_loaded = true;
        return;
      }
      const prevLen = this.podcasts_episodes.length;
      this.episode_service.getAllPodcastEpisodes(this.limit, ++this.page)
        .then((tempArr) => {
          this.podcasts_episodes = this.podcasts_episodes.concat(this.mapPodcastEpisodeData(tempArr.episodes));
          this.no_more_episodes = this.podcasts_episodes.length === prevLen;
          this.loading_more_episodes = false;
          this.episodes_loaded = true;
        })
        .catch(() => {
          this.no_more_episodes = true;
          this.loading_more_episodes = false;
          this.episodes_loaded = true;
        });
    },
    mapPodcastEpisodeData(temp) {
      temp = temp.map(item => ({
        ...item,
        progress: item.episode_listen ? item.episode_listen.elapsed : 0,
        display_image_url: item.display_image_url || item.image_url,
        image_url: item.display_image_url || item.image_url,
      }));
      return temp;
    },
    ifiniteScrollPodcastEpisodes() {
      // if (!this.podcasts_episodes.length) return;
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
      document.getElementsByTagName('body')[0].addEventListener('scroll', this.infiniteScrollPodcastEpisodesCallBack);
    },
    infiniteScrollPodcastEpisodesCallBack() {
      const heightLimit = document.body.scrollTop + window.innerHeight + this.scroll_threshold >= document.body.scrollHeight;
      if (heightLimit && !this.loading_more_episodes) {
        this.loadPodcastEpisodeData();
      }
    },
    removeScrollEvent() {
      const body = document.getElementsByTagName('body')[0];
      body.style = {};
      document.getElementsByTagName('body')[0].removeEventListener('scroll', this.infiniteScrollPodcastEpisodesCallBack);
    },
    // deleteEpisode(id, index) {
    //   if (!id) return;
    //   this.podcasts_episodes[index].in_library = false;
    // },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

@media(max-width: 1024px) {
  .podcast-episodes {
    .container {
      width: 100%;
      .top-bar {
        margin: 0 32px;
        padding-bottom: 13px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/user_library/PodcastEpisodes.vue